/**
 * Emerald Money Changer wordmark logo.
 * The source image is served from /emerald-logo.png. Because the artwork
 * is dark on transparent, we auto-invert on dark backgrounds via CSS filter.
 *
 * <BrandLogo /> — default medium size for headers / login
 * <BrandLogo size="sm" /> — compact for tight sidebars
 * <BrandLogo variant="dark" /> — force invert (use on dark bg)
 */
export const BrandLogo = ({
  size = "md",
  variant = "light",
  className = "",
  alt = "Emerald Money Changer",
}) => {
  const heights = { xs: "h-5", sm: "h-6", md: "h-8", lg: "h-11", xl: "h-14" };
  const h = heights[size] || heights.md;
  const invert = variant === "dark" ? "invert brightness-0 contrast-200" : "";
  return (
    <img
      src="/emerald-logo.png"
      alt={alt}
      className={`brand-logo ${h} w-auto object-contain select-none ${invert} ${className}`}
      draggable="false"
    />
  );
};
